// extracted by mini-css-extract-plugin
export default {"form":"UpdateForm_form__k3ycD","createButton":"UpdateForm_createButton__uh5yi","appear":"UpdateForm_appear__Iv4hq"};